/**
 * 勾标记svg
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/21
 */
import React from 'react';

const Tick = () => {
  return <svg viewBox="0 0 1024 1024" className="store-svg-tick">
    <path d="M369.935 651.164l-220.211-220.206-114.068 114.063 331.178 331.164 623.888-623.862-113.421-108.505z" />
  </svg>
};

export default Tick


// WEBPACK FOOTER //
// ./src/svgs/tick.js